<template>
  <div>
    <div ref="container" class="x-scroll-container w-100" @scroll="onScroll">
      <!-- Items Loop -->
      <product-card
        v-for="(product, index) in products"
        :key="index"
        :item="product"
        :community="space_target"
      />
      <!-- Buttons prev and next -->
      <button
        class="link-previous btn btn-icon btn-primary btn-previous"
        @click="scrollOnePage(-1)"
      >
        <b-spinner small class="spinner" />
      </button>
      <button
        class="link-next btn btn-icon btn-primary btn-next"
        :class="{ 'btn-next--loading': isLoadingNextPage }"
        @click="scrollOnePage(+1)"
      >
        <b-spinner small class="spinner" />
      </button>
    </div>
  </div>
</template>

<script>
import ProductCard from "@/views/apps/products/components/ProductCard.vue";

export default {
  name: "ProductsDetailPreview",
  components: {
    ProductCard,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    community: {
      type: Object,
      required: true,
    },
    space_target: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      isLoadingNextPage: false,
      lastLoadedPage: 1,
      isLoading: false,
    };
  },
  computed: {
    itemsData() {
      return this.$store.getters.products;
    },
  },
  methods: {
    async onScroll(event) {
      const distanceToEnd =
        event.srcElement.scrollWidth -
        event.srcElement.scrollLeft -
        event.srcElement.offsetWidth;
      if (distanceToEnd < 50 && !this.isLoadingNextPage) {
        this.handleLoadOfNewItems();
      }
    },
    // Scroll forward and back (buttons)
    scrollOnePage(direction) {
      const currentScroll = this.$refs.container.scrollLeft;
      const toScroll = this.$refs.container.offsetWidth;
      this.$scrollTo(this.$refs.container, 500, {
        container: this.$refs.container,
        duration: 500,
        offset: currentScroll + direction * toScroll,
        x: true,
        y: false,
      });
    },
    // Load more items
    async handleLoadOfNewItems() {
      const { total } = this.itemsData.meta;
      if (!this.isLoading && this.products.length < total) {
        this.lastLoadedPage += 1;
        this.isLoadingNextPage = true;
        await this.fetchData();
        this.isLoadingNextPage = false;
      }
    },
    async fetchData(force = false) {
      this.isLoading = true;
      const response = await this.$store.dispatch("getItems", {
        itemType: "products",
        page: this.lastLoadedPage,
        forceAPICall: force,
        communitySlug: this.community?.slug,
        requestConfig: {
          count: 16,
          orderByDate: -1,
        },
      });
      this.products = [...this.products, ...response.data];

      this.isLoading = false;
    },
  },
};
</script>

<style></style>
